import { CalendarDayBase } from './CalendarDay.base';
import { styles } from './CalendarDay.styles';
import { styled } from '../../../Utilities';
export var CalendarDay = styled(CalendarDayBase, styles, undefined, {
    scope: 'CalendarDay',
});
//# sourceMappingURL=CalendarDay.js.map